import { toast } from "react-toastify";

// TODO: Handle at RTK query level?
export const handleServerErrorResponse = (response, intl, formRef) => {
  if (response?.response?.status === 400) {
    const { buildErrorsFromResponse } = serverValidationHelper(intl);

    let errors = buildErrorsFromResponse(response.response.data?.data);
    if (!errors) errors = [];

    //Clean up dupes..
    errors = [...new Set(errors)];

    errors.unshift(
      intl.formatMessage({
        id: "general.validationErrorMessage",
        defaultMessage: "Validation Failed",
      })
    );

    toast.error(() => (
      <div>
        {errors.map((e, i) => (
          <span key={i}>
            {e}
            <br />
          </span>
        ))}
      </div>
    ));
    if (formRef?.current) {
      formRef.current.validateFields();
    }
  } else if (response?.response?.status === 403) {
    toast.error(intl.formatMessage({ id: "general.accessDenied" }));
  } else if (response?.response?.status === 401) {
    toast.error(intl.formatMessage({ id: "general.unauthorized" }));
  } else {
    toast.error(intl.formatMessage({ id: "general.toastSomethingWentWrong" }));
  }
};

export const serverValidationHelper = (intl) => {
  const getValidationErrorInfo = (target, id, submitErrors) => {
    const checkChildren = (item) => {
      if (item.Children) {
        for (const child in item.Children) {
          if (Object.prototype.hasOwnProperty.call(item.Children, child)) {
            const childValue = item.Children[child];
            if (Array.isArray(childValue)) {
              for (const childArrIdx in childValue) {
                if (
                  Object.prototype.hasOwnProperty.call(childValue, childArrIdx)
                ) {
                  const childArrItem = childValue[childArrIdx];
                  if (
                    childArrItem.id === id &&
                    childArrItem.Target === target
                  ) {
                    return childArrItem;
                  }
                  const cv = checkChildren(childArrItem);
                  if (cv) return cv;
                }
              }
            } else if (childValue.id === id && childValue.Target === target) {
              return childValue;
            }
            const cv = checkChildren(childValue);
            if (cv) return cv;
          }
        }
      }
      return undefined;
    };

    if (submitErrors) {
      if ((submitErrors.id === id || !id) && submitErrors.Target === target) {
        return submitErrors;
      }
      return checkChildren(submitErrors);
    }
    return undefined;
  };

  const getPropertyValidationErrors = (
    target,
    id,
    propertyName,
    submitErrors
  ) => {
    const vi = getValidationErrorInfo(target, id, submitErrors);

    if (vi?.Errors) {
      return vi.Errors.filter((f) => f.PropertyName === propertyName).map((e) =>
        intl.formatMessage({
          id: e.ErrorMessage || "general.genericRequiredMessage",
          defaultMessage: e.ErrorMessage,
        })
      );
    }
    return [];
  };

  const buildErrorsFromResponse = (submitErrors) => {
    const errors = [];
    getFormattedErrors(submitErrors, errors, true);
    return errors;
  };

  const getErrorsWithChildren = (target, id, submitErrors) => {
    const vi = getValidationErrorInfo(target, id, submitErrors);
    if (vi) {
      return buildErrorsFromResponse(vi);
    }
    return undefined;
  };

  const getFormattedErrors = (error, errorList, isTopLevel) => {
    if (error) {
      if (Array.isArray(error)) {
        for (const element of error) {
          getFormattedErrors(element, errorList, false);
        }
      } else {
        if (Object.prototype.hasOwnProperty.call(error, "Errors")) {
          for (const errorObject of error.Errors) {
            errorList.push(formatError(errorObject, isTopLevel, error.Target));
          }
        }
        if (Object.prototype.hasOwnProperty.call(error, "Children")) {
          for (const child in error.Children) {
            getFormattedErrors(error.Children[child], errorList, false);
          }
        }
      }
    }
    return errorList;
  };

  const formatError = (error, isTopLevel, target) => {
    let translatedMessage = "";
    if (error.ErrorMessage) {
      translatedMessage = intl.formatMessage({
        id: error.ErrorMessage,
        defaultMessage: error.ErrorMessage,
      });
    } else {
      translatedMessage = intl.formatMessage({
        id: "general.genericRequiredMessage",
      });
    }

    return `${isTopLevel ? error.PropertyName : target}: ${translatedMessage}`;
  };

  return {
    getPropertyValidationErrors,
    getValidationErrorInfo,
    getErrorsWithChildren,
    buildErrorsFromResponse,
  };
};
